import React from "react";
import UnitPricesPage from "./UnitPricesPage";

const ANZUnitPrice = () => (
    <UnitPricesPage
        pageTitle="ANZ Unit Prices"
        reportName="ANZUnitPrice"
        localFilePath={process.env.REACT_APP_ANZ_UNIT_PRICE_LOCAL_DATA}
    />
);

export default ANZUnitPrice;